import { createAction } from '@reduxjs/toolkit';

import type { LoginTypes } from '@modules';
import api from '@modules/api';
import { createAsyncActions, createActions } from '@modules/helpers';

const actions = createActions('login', {
  clearNext: name => createAction<void>(name),

  clearProtectNext: name => createAction<void>(name),

  clearErrors: name => createAction<void>(name),

  updateTimeout: name => createAction<number>(name),
});

export const asyncActions = createAsyncActions('login', {
  login: (data: LoginTypes.LoginParams, thunkApi) =>
    api.post<LoginTypes.LoginResponse>(thunkApi, '/user22/sign-in', data),

  verifyPhone: (data: LoginTypes.VerifyPhoneParams, thunkApi) => {
    const url = '/user22/sign-in/verify-phone';
    return api.post<LoginTypes.VerifyPhoneResponse>(thunkApi, url, data);
  },

  verifyPassword: (data: LoginTypes.VerifyPasswordParams, thunkApi) => {
    const url = '/user22/sign-in/verify-password';
    return api.post<LoginTypes.VerifyPasswordResponse>(thunkApi, url, data);
  },

  setEmail: (data: LoginTypes.SetEmailParams, thunkApi) => {
    const url = '/user22/sign-in/set-email';
    return api.post<LoginTypes.SetEmailResponse>(thunkApi, url, data);
  },

  verifyEmail: (data: LoginTypes.VerifyEmailParams, thunkApi) => {
    const url = '/user22/sign-in/verify-email';
    return api.post<LoginTypes.VerifyPhoneResponse>(thunkApi, url, data);
  },

  resetPasswordEmail: (data: LoginTypes.ResetPasswordParams, thunkApi) => {
    const url = '/user22/change-password/send-email';
    return api.post<LoginTypes.ResetPasswordResponse>(thunkApi, url, data);
  },

  resetPasswordPhone: (data: LoginTypes.ResetPasswordParams, thunkApi) => {
    const url = '/user22/change-password/send-sms';
    return api.post<LoginTypes.ResetPasswordResponse>(thunkApi, url, data);
  },

  resetPasswordVerifyEmail: (data: LoginTypes.ResetPasswordVerifyEmailParams, thunkApi) => {
    const url = '/user22/change-password/verify-email';
    return api.post<LoginTypes.ResetPasswordVerifyEmailResponse>(thunkApi, url, data);
  },

  resetPasswordVerifyOTP: (data: LoginTypes.ResetPasswordVerifyOTPParams, thunkApi) => {
    const url = '/user22/change-password/verify-otp';
    return api.post<LoginTypes.ResetPasswordVerifyOTPResponse>(thunkApi, url, data);
  },

  resetPasswordVerifyPhone: (data: LoginTypes.ResetPasswordVerifyPhoneParams, thunkApi) => {
    const url = '/user22/change-password/verify-phone';
    return api.post<LoginTypes.ResetPasswordVerifyPhoneResponse>(thunkApi, url, data);
  },

  setPassword: (data: LoginTypes.SetPasswordParams, thunkApi) => {
    const url = '/user22/change-password/set-password';
    return api.post<LoginTypes.SetPasswordResponse>(thunkApi, url, data);
  },

  logout: (_: void, thunkApi) => api.get<void>(thunkApi, '/user22/logout'),

  resendVerification: (data: LoginTypes.ResendVerificationParams, thunkApi) => {
    const url = '/verification/resend';
    return api.post<LoginTypes.ResendVerificationResponse>(thunkApi, url, data);
  },

  keepAlive: (_: void, thunkApi) => {
    const url = '/user22/keep-alive';
    return api.get<LoginTypes.LoginEmptyResponse>(thunkApi, url);
  },
});

export default { ...actions, ...asyncActions };
